define('../app/fukit/behavior/show.field.validations.behavior',['require','exports','module','underscore','marionette','uikit/uikit','backbone'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Mn       = require('marionette'),
      UIKit    = require('uikit/uikit'),
      Backbone = require('backbone');

  var ShowFieldValidationsBehavior = Mn.Behavior.extend({
    defaults: {
      valueOption: 'value',
      fieldAttribute: 'field',
      messageAttribute: 'message',
      errorLabelOptions: {
        color: 'red',
        prompt: true,
        pointing: true,
      },
    },

    initialize: function() {
      this.once('before:render', this.setupModelEvents, this);
    },

    setupModelEvents: function() {
      var model = this.getModel();
      this.listenTo(model, 'validated', this.onModelValidated);
    },

    onModelValidated: function(model, isValid, validations) {
      var errors = this.getFilteredErrors(validations);

      _.invoke(this.previousErrorLabels, 'destroy');

      if (errors.length > 0) {
        this.view.state = 'error';
        var errorLabels = _.chain(errors)
          .map(function(error) {
            return this.buildLabelView({
              model: new Backbone.Model(error),
              bindings: { text: 'message' },
            });
          }, this)
          .each(function(errorLabel) {
            errorLabel.render();
            this.$el.append(errorLabel.$el);
          }, this)
          .value();

        this.previousErrorLabels = errorLabels;
      } else {
        this.previousErrorLabels = [];
        this.view.state = null;
      }
    },

    buildLabelView: function(options) {
      return new UIKit.Label(_.extend({}, options, Mn._getValue(this.getOption('errorLabelOptions'), this)));
    },

    getModel: function() {
      return this.view.contentView ? this.view.contentView.model : this.view.model;
    },

    getBindings: function() {
      return this.view.contentView ? this.view.contentView.bindings : this.view.bindings;
    },

    getFilteredErrors: function(validations) {
      //prettier-ignore
      var bindings         = this.getBindings() || {},
          valueOption      = this.getOption('valueOption'),
          fieldAttribute   = this.getOption('fieldAttribute'),
          messageAttribute = this.getOption('messageAttribute'),
          valueBinding     = bindings[valueOption];

      return _.chain(validations)
        .filter(function(validation) {
          return validation && validation[fieldAttribute] == valueBinding;
        })
        .map(function(validation) {
          return {
            field: validation[fieldAttribute],
            message: validation[messageAttribute],
          };
        })
        .value();
    },
  });

  module.exports = ShowFieldValidationsBehavior;
});

